export default __webpack_public_path__ + "static/media/add_to_slack_white.1a7e1137.png";